// React
import React, { Component } from "react";

// Libraries
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import Numeral from 'numeral';

// ErrorHandler
import { ErrorHandler } from '../../Utils';

// Panel
import { PanelHeading, PanelBody } from '../../Components';

// Stores
import { UserProfileStore, SampleDataStore, CurrencyStore }  from '../../Stores';

// Styles
import "./dashboard.css";

class CurrencyHistory extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            loading : true,
            data : {
                'BTC' : {},
                'USD' : {}
            },
            quoteCurrency : 'USD',
            description: ["The total profit or loss earned on each currency from the last x number of days.", "The mini chart shows how your trading is trending on each coin."],
            message : null
        };

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('CurrencyHistory.componentDidMount()');

        // If user logged in, listen for updates
        // and fetch the hist pnl data
        if(this.props.user !== null) {
            this.listenForUpdates();
            this.getCurrencyHistory();
        }
        else {
            this.getSampleCurrencyHistory();
        }

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieves and displays the currency history
    getCurrencyHistory() {

        //console.log('CurrencyHistory.getCurrencyHistory()');

        const currencies = UserProfileStore.getHistCurrencies();

        if(currencies !== null) {

            const formatted = this.formatCurrencies(currencies);
            
            this.setState((prev, props) => {
                return {
                    loading: false,
                    data : formatted
                }
            });
        }

    }


    // Formats the currencies
    formatCurrencies(coinSummary) {

        var totals = {};

        for(let[quoteCurrency, dates] of Object.entries(coinSummary)) {

            var currencies = {};

            for(let[date, coins] of Object.entries(dates)) {

                for(let[ticker, pnlToDate] of Object.entries(coins)) {

                    if(currencies[ticker] === undefined) {
                        currencies[ticker] = {
                            total : {date : date, value : pnlToDate},
                            name : CurrencyStore.getCoinName(ticker),
                            history : []
                        }
                    }

                    // save each date in history with timestamp and value
                    var dateObj = {
                        date : date,
                        value : pnlToDate
                    };
                    currencies[ticker].history.push(dateObj);

                    // find last timestamp and save that pnlToDate as total
                    if(date > currencies[ticker].total.date) {
                        currencies[ticker].total = {date : date, value : pnlToDate};
                    }

                }

            }

            totals[quoteCurrency] = currencies;

        }

        return totals;

    }


    // Listen for updates to hist pnl
    listenForUpdates() {
        
        var emitter = UserProfileStore.getEmitter();

        // Listen for pnl updates
        emitter.addListener('histPnl', (updated) => {

            if(updated) {
                this.getCurrencyHistory();
            }
            else {

                const error = UserProfileStore.getHistPnlError();

                var msg = ErrorHandler.currencyHistoryError(error);

                this.setState((prev, props) => {
                    return {
                        message : msg,
                        loading : false
                    }
                });
            }

        });

        // Listen for loading indicator
        emitter.addListener('loadingHistPnl', (loading) => {

            if(loading) {
                this.setState((prev, props) => {
                    return {
                        loading : true
                    }
                });
            }

        });

    }


    // Retrieves and displays the sample currency history
    getSampleCurrencyHistory() {

        const currencyHistory = SampleDataStore.getCurrencyHistoryData();
        
        this.setState((prev, props) => {
            return {
                loading : false,
                data : currencyHistory
            }
        });

    }

    // Selecing a quote currency will update the dropdown,
    // decimal formatting and the currency symbol
    selectQuoteCurrency = (ticker) => {

        //console.log('CurrencyHistory.selectQuoteCurrency()');

        this.setState((prev, props) => {
            return {
                quoteCurrency : ticker,
                currencySymbol : CurrencyStore.getCurrencySymbol(ticker),
                decimals : CurrencyStore.getFormat(ticker)
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('CurrencyHistory.render()');

    const currencies = this.state.data[this.state.quoteCurrency];

    return (

        <div className="panel panel-flat bg-theme-700">

            <PanelHeading title={"Currency PnL"} description={this.state.description} sample={this.props.user === null ? true : false} refresh={null}>

                {/*<div className="button-row">

                    <div className="dropdown">
                        <a type="button" className="btn btn-link dropdown-toggle legitRipple" 
                        data-toggle="dropdown" aria-expanded="true"> {this.state.quoteCurrency}
                        <span className="caret"></span></a>
                        <ul className="dropdown-menu">
                            <li onClick={this.selectQuoteCurrency('USD')}><a href="#">USD</a></li>
                            <li onClick={this.selectQuoteCurrency('BTC')}><a href="#">BTC</a></li>
                        </ul>
                    </div>

    </div>*/}

            </PanelHeading>

            <PanelBody loading={this.state.loading} message={this.state.message}>

                <div className="row">

                    {
                        Object.keys(currencies).sort().map( (ticker) => {

                            return (

                                <div className="flex-panel" key={ticker}>

                                    <div className="child-row">

                                        <div className="rox-box left">

                                            <div>
                                                { currencies[ticker].name }
                                            </div>
                                            <div className="lowlight">
                                               {ticker}
                                            </div>

                                        </div>

                                        <div className="row-box mini-chart">
                                            <ResponsiveContainer className="graph" width="100%" height={42}>
                                            <LineChart data={currencies[ticker].history}>
                                                <Line type='monotone' dataKey='value' stroke="#EC407A" strokeWidth={2} dot={{r:1}}/>
                                            </LineChart>
                                            </ResponsiveContainer>
                                        </div>

                                        <div className="rox-box right">

                                            <div>
                                                Total
                                            </div>
                                            <div>
                                                <span className="right-pad">{ this.state.currencySymbol }</span>
                                                { Numeral(currencies[ticker].total.value).format(CurrencyStore.getFormat(this.state.quoteCurrency)) }
                                            </div>

                                        </div>

                                    </div>


                                </div>

                            )
                        })
                    }
                </div>

            </PanelBody>

        </div>

    );
  }

}

export default CurrencyHistory;





// WEBPACK FOOTER //
// ./src/Views/Dashboard/CurrencyHistory.js